import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { Galerie } from '@components/galerie/models';
import { ImageComponent } from '@shared/components/image';
import { Image } from '@shared/components/image/models';
import { TitleComponent } from '@shared/components/title';

@Component({
  selector: 'app-galerie-2it4i',
  imports: [TitleComponent, ImageComponent],
  templateUrl: './galerie-2it4i.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Galerie2it4iComponent extends AbstractDynamicComponent<Galerie> {
  zoomImageRequested = output<Image>();
}
